module.exports = __webpack_public_path__ + "7a5de118e6ea4302741bcebcdadb2e28.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-8.png
// module id = 2582
// module chunks = 0